    function updateVariantDataSingleProduct($target){
      setTimeout(function(){
        let $el=$('select.variants-ui__select-main');
        let selected_variant_id=$el.val();
        let $option=$el.find(":selected");
        let available=$option.data('available');
        let delivery_time_selector='.primer_delivery_time';
        let available_selector=delivery_time_selector+'__available';
        let unavailable_selector=delivery_time_selector+'__unavailable';

        if(available){
          $(unavailable_selector).hide();
          $(available_selector).show();
        }else{
          $(available_selector).hide();
          $(unavailable_selector).show();
        }

        //console.log($target)
        //console.log($target.find(":selected"))

        $($('.product__unit-price')).addClass("hidden") 
        $($('.product__unit-price-' + $($target).find(":selected").data("variantId"))).removeClass("hidden") 
        
        let url = $($target).find(":selected").data("variantUrl");
        let nextTitle = '';
        let nextState = {  };
        window.history.replaceState(nextState, nextTitle, url);
        
        });
      

    }